import ConfirmationScreen from './ConfirmationScreen';

export default ConfirmationScreen;
